import { ImSys } from '../../core/ImSys.js';
import { toArray } from '../../core/items/ItemsController.js';
import { ViewCmdType } from '../../view/IViewWidget.js';
import { ViewWidgetHelper } from '../../view/ViewWidgetHelper.js';
import { CollectionServerCmd } from './ICollectionWidget.js';
import { ServerCallback } from '../../core/cmd/ServerCommand.js';

/**
 * Контроллер предметных операций для CollectionWidget.
 * Выносит серверные вызовы и операции выбора из виджета,
 * оставляя в виджете только визуальную/DOM-часть.
 */
class CollectionItemsController {
    constructor(widget) {
        this._w = widget;
    }
    // ── Выбор ────────────────────────────────
    /** Сделать текущими только указанные элементы (остальные снять) */
    select(ids) {
        const wanted = new Set(toArray(ids).map(String));
        this._w.queryItems().forEach(it => {
            const v = this._w.getItemVal(it);
            this._w.setItemChecked(it, v != null && wanted.has(v));
        });
        this._w.recountAndEmit();
    }
    /** Отметить все доступные для выбора элементы */
    selectAll() {
        this._selectableItems().forEach(i => this._w.setItemChecked(i, true));
        this._w.recountAndEmit();
    }
    /** Снять выделение с указанных элементов (остальные оставить) */
    unselect(ids) {
        const unwanted = new Set(toArray(ids).map(String));
        this._w.queryItems().forEach(it => {
            const v = this._w.getItemVal(it);
            if (v != null && unwanted.has(v)) {
                this._w.setItemChecked(it, false);
            }
        });
        this._w.recountAndEmit();
    }
    /** Снять выделение со всех элементов */
    unselectAll() {
        this._w.queryItems().forEach(i => this._w.setItemChecked(i, false));
        this._w.recountAndEmit();
    }
    /**
     * Обратить выделение. 2026-10-13: учитываются только доступные элементы —
     * недоступная строка не мешает «выбрать все» стать отметкой «сняты все».
     */
    toggle() {
        const items = this._selectableItems();
        const hasUnchecked = items.some(i => !i.classList.contains('checked'));
        items.forEach(i => this._w.setItemChecked(i, hasUnchecked));
        this._w.recountAndEmit();
    }
    // ── CRUD (частично) ──────────────────────
    /** Удалить все выбранные элементы */
    deleteSelected() {
        // Повторяем логику onCmdPanelClick("delete-rows"), но без панели
        const selected = this._w.getSelected();
        if (selected.length === 0)
            return;
        this.exec(CollectionServerCmd.delete_rows, { rowindexes: selected.join(",") });
    }
    /** Полностью перезагрузить содержимое коллекции */
    reloadAll(ids) {
        this.exec(CollectionServerCmd.reloadContent, undefined, (data) => {
            this._w.reloadComplete(data?.html);
            if (ids)
                this.select(ids);
        });
    }
    // ── Вспомогательные ──────────────────────
    /** Элементы, которые можно выбрать (2026-10-13) */
    _selectableItems() {
        return this._w.queryItems().filter(i => this._w.isItemSelectable?.(i) ?? true);
    }
    /** Унифицированный ExecCmd */
    exec(cmd, options, onSuccess, onError) {
        const args = {
            cmdType: ViewCmdType.itemcmd,
            cmd: cmd,
            options: options,
            onSuccess: (res) => {
                this._w.panel?.setBusy(false);
                if (res?.type == ServerCallback.cbMsg && res.msg)
                    ImSys.alert('', res.msg);
                onSuccess?.(res);
            },
            onError: (err) => {
                this._w.panel?.setBusy(false);
                console.error('Cmd error', err);
                onError?.(err);
            },
            setBusy: true
        };
        this._w.panel?.setBusy(true);
        ViewWidgetHelper.ExecCmd(this._w.element, args);
    }
}

export { CollectionItemsController };
